export function toGeoJSON(polygon) {
  return {
    type: "Feature",
    properties: {
      id: polygon.id,
      name: polygon.name,
      polygonModeId: polygon.polygonModeId,
      polygonModeName: polygon.polygonModeName,
      polygonColor: polygon.polygonColor,
      value: polygon.value,
    },
    geometry: {
      type: polygon.geometryType, // "Polygon"
      coordinates: [
        [
          ...polygon.coordinates.map((c) => [c.x, c.y]), // GeoJSON은 [lon, lat]
        ],
      ],
    },
  };
}
